import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCopyright } from "@fortawesome/free-solid-svg-icons";

export default function Footer() {
  return (
    <footer className="footer-vtc">
      <div className="footer-content">
        <Link to="/cgu" className="footer-link">
          CGU
        </Link>

        <span className="footer-separator">•</span>

        <Link to="/mentions-legales" className="footer-link">
          Mentions légales
        </Link>

        <span className="footer-separator">•</span>

        <span className="footer-copy">
          <FontAwesomeIcon icon={faCopyright} /> {new Date().getFullYear()} IAC
          Design Digital
        </span>
      </div>
    </footer>
  );
}
